<div class="container-fluid p-3">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ payload?.proposal_name }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">


        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>


  <hr class="my-3" />

  <!-- Firm Capability Required - COMMENTED OUT: Moved to revenue-bid component -->
  <!-- <div class="bg-white rounded-md border border-slate-300 px-4 py-3 sm:px-6 sm:py-4 mb-4" *ngIf="schemeType =='rev' && stepDetails?.code === 'R-TN'">
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

      <div>
        <h4 class="text-base sm:text-lg font-semibold text-slate-800">
          Firm Capacity Required
        </h4>
        <p class="text-sm text-slate-500">
          Please specify whether firm capacity is required for this proposal
        </p>
      </div>

      <div class="flex items-center gap-6">

        <label class="flex items-center gap-2 cursor-pointer">
          <input type="radio" name="firmCapability" value="yes" [(ngModel)]="firmCapacityRequired"
            class="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" />
          <span class="text-sm font-medium text-slate-700">Yes</span>
        </label>

        <label class="flex items-center gap-2 cursor-pointer">
          <input type="radio" name="firmCapability" value="no" [(ngModel)]="firmCapacityRequired"
            class="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" />
          <span class="text-sm font-medium text-slate-700">No</span>
        </label>

      </div>

    </div>
  </div>

  <hr class="my-3" /> -->


  <!-- R-TN Specific Fields -->
  <!-- <div class="card shadow-sm border-0 p-4 mb-4" *ngIf="stepDetails?.code === 'R-TN'">
    <h5 class="mb-3 text-primary">Meeting Details</h5>
    <div class="row g-3">
      <div class="col-md-4">
        <label for="meeting_date" class="form-label">Meeting Date</label>
        <input
          type="date"
          id="meeting_date"
          class="form-control"
          [(ngModel)]="meeting_date"
          [disabled]="!stepDetails?.can_edit"
        />
      </div>
      <div class="col-md-4">
        <label for="meeting_time" class="form-label">Meeting Time</label>
        <input
          type="time"
          id="meeting_time"
          class="form-control"
          [(ngModel)]="meeting_time"
          [disabled]="!stepDetails?.can_edit"
        />
      </div>
      <div class="col-md-4">
        <label for="meeting_venue" class="form-label">Meeting Venue</label>
        <textarea
          id="meeting_venue"
          class="form-control"
          [(ngModel)]="meeting_venue"
          placeholder="Enter meeting venue"
          rows="3"
          [disabled]="!stepDetails?.can_edit"
        ></textarea>
      </div>
    </div>
    <div class="row mt-3" *ngIf="stepDetails?.can_edit">
      <div class="col-12 d-flex justify-content-end">
        <button 
          class="btn btn-primary"
          (click)="updateTnFields()"
        >
          <i class="pi pi-save me-1"></i> Save Meeting Details
        </button>
      </div>
    </div>
  </div> -->

  <!-- <div class="row mb-4">
        <div class="col-md-6">
            <div class="card p-3">
                <h5>Technical Negotiations By TNC</h5>
                <p class="text-muted">Upload the Technical Negotiations By TNC document</p>
                <p-fileUpload mode="basic" chooseLabel="Upload Technical Negotiations By TNC" [auto]="true"
                    (uploadHandler)="onUpload($event)" [customUpload]="true" #fileUpload [multiple]="false"
                    styleClass="p-button-outlined w-100">
                </p-fileUpload>
                <div class="mt-3" *ngIf="uploadedFileName">
                    <div class="d-flex justify-content-between align-items-center">
                        <span> <a target="_blank"> {{ uploadedFileName }}</a></span>
                        <button class="btn btn-sm" (click)="clearUpload(fileUpload)">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                </div>
                <div class="mt-3" *ngIf="uploadedUrl">
                    <div class="d-flex justify-content-between align-items-center">
                        <span> <a [href]="apiUrl + uploadedUrl" target="_blank"> {{ getFileName(uploadedUrl)
                                }}</a></span>
                        <div class="d-flex gap-2">
                            <a [href]="apiUrl + uploadedUrl" target="_blank">
                                <p-button icon="pi pi-eye" styleClass="p-button-sm p-button-outlined"
                                    pTooltip="View Document"></p-button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <form [formGroup]="tncForm">
        <div class="mb-4 editor-container">
            <label class="mb-2 d-block">Technical Negotiations By TNC <b class="text-danger">*</b>

            </label>
            <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="tnc"></ckeditor>
        </div>
    </form> -->

  <div class="overflow-x-auto">
    <div class="overflow-x-auto">
  <p-table [value]="vendors" editMode="row" dataKey="id" #table>

    <!-- HEADER -->
    <ng-template pTemplate="header">
      <tr>
        <th>Vendor Name</th>
        <th>Vendor Address</th>
        <th>Upload Doc</th>
        <th>Status</th>
        <th>Meeting Date</th>
        <th>Meeting Time</th>
        <th>Meeting Venue</th>
        <th>Firm Representatives</th>
        <th *ngIf="stepDetails?.can_edit">Actions</th>
      </tr>
    </ng-template>

    <!-- BODY -->
    <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="rowData">

        <!-- Vendor -->
        <td>{{ rowData.vendor?.name || '-' }}</td>
        <td>{{ rowData.vendor?.address || '-' }}</td>

        <!-- File Upload -->
        <td>
          <ng-container *ngIf="editing; else showFile">
            <input type="file" (change)="onFileUpload($event, rowData)" />
          </ng-container>

          <ng-template #showFile>
            <a *ngIf="rowData.file; else noFile"
               [href]="apiUrl + rowData.file"
               target="_blank">
              {{ getFileName(rowData.file) }}
            </a>
            <ng-template #noFile>No file</ng-template>
          </ng-template>
        </td>

        <!-- Status -->
        <td>
  <!-- EDIT MODE -->
  <div *ngIf="editing; else viewMode" class="flex items-center gap-4">

    <!-- Qualified -->
    <div class="flex items-center gap-1">
      <p-radioButton
        name="status{{ri}}"
        value="Qualify"
        [(ngModel)]="rowData.status">
      </p-radioButton>
      <label>Qualified</label>
    </div>

    <!-- Disqualified -->
    <div class="flex items-center gap-1">
      <p-radioButton
        name="status{{ri}}"
        value="Disqualify"
        [(ngModel)]="rowData.status">
      </p-radioButton>
      <label>Disqualified</label>
    </div>

  </div>

  <!-- VIEW MODE -->
  <ng-template #viewMode>
    <span [ngClass]="{
      'text-success font-semibold': rowData.status === 'Qualify',
      'text-danger font-semibold': rowData.status === 'Disqualify'
    }">
      {{ rowData.status === 'Qualify' ? 'Qualified' :
         rowData.status === 'Disqualify' ? 'Disqualified' : '-' }}
    </span>
  </ng-template>
</td>

        <!-- Meeting Date -->
        <td>
          <ng-container *ngIf="editing; else viewDate">
            <input type="date" [(ngModel)]="rowData.date" class="form-control" />
          </ng-container>
          <ng-template #viewDate>
            {{ rowData.date || '-' }}
          </ng-template>
        </td>

        <!-- Meeting Time -->
        <td>
          <ng-container *ngIf="editing; else viewTime">
            <input type="time" [(ngModel)]="rowData.time" class="form-control" />
          </ng-container>
          <ng-template #viewTime>
            {{ rowData.time || '-' }}
          </ng-template>
        </td>

        <!-- Meeting Venue -->
        <td>
          <ng-container *ngIf="editing; else viewVenue">
            <input type="text" [(ngModel)]="rowData.venue" class="form-control" />
          </ng-container>
          <ng-template #viewVenue>
            {{ rowData.venue || '-' }}
          </ng-template>
        </td>

        <!-- Firm Representatives -->
        <td>
          <ng-container *ngIf="editing; else viewRep">
            <input type="text"
              [(ngModel)]="rowData.firm_representatives"
              class="form-control" />
          </ng-container>
          <ng-template #viewRep>
            {{ rowData.firm_representatives || '-' }}
          </ng-template>
        </td>

        <!-- Actions -->
   <td *ngIf="stepDetails?.can_edit">
  <div class="flex items-center gap-2 whitespace-nowrap">

    <!-- Edit -->
    <button *ngIf="!editing"
      class="btn btn-outline-primary btn-sm"
      (click)="table.initRowEdit(rowData)">
      ✏️
    </button>

    <!-- Save -->
    <button *ngIf="editing"
      class="btn btn-success btn-sm"
      (click)="onRowEditSave(rowData)">
      ✔
    </button>

    <!-- Cancel -->
    <button *ngIf="editing"
      class="btn btn-danger btn-sm"
      (click)="table.cancelRowEdit(rowData)">
      ❌
    </button>

  </div>
</td>

      </tr>
    </ng-template>

  </p-table>
</div>


    <!-- Document Upload Section -->
    <div class="mt-4 mb-4">
      <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>
    </div>

    <!-- Selected Committee (readonly) – visible only for schemeType rev, design from constitute-committee -->
    <ng-container *ngIf="stepDetails?.code == 'R-TN' && committees?.length ">
      <div *ngFor="let committee of committees"
        class="w-full mx-auto my-6 shadow-lg rounded-lg bg-white border border-slate-200 transition-all duration-200 hover:shadow-2xl">
        <!-- Committee Header (same as constitute-committee.component.html) -->
        <div
          class="flex flex-col sm:flex-row sm:justify-between sm:items-center bg-gradient-to-r from-blue-100 to-blue-50 p-5 py-2 border-b-2 border-blue-200 rounded-t-lg">
          <div class="flex items-center gap-2">
            <span
              class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-200 text-blue-700 text-xl font-bold shadow-sm">
              <i class="pi pi-users"></i>
            </span>
            <span class="font-bold text-2xl text-slate-800 tracking-tight">{{ committee.name }}</span>
            <span class="inline-block ml-3 bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-xs font-semibold"
              *ngIf="committee.members?.length > 0">
              {{ committee.members.length }} Members
            </span>
          </div>
        </div>
        <!-- End Committee Header -->
        <div class="px-3 py-3">
          <div class="rounded-md border border-blue-100 bg-blue-50/50 p-2 mb-4" *ngIf="committee.description">
            <span class="text-sm text-blue-700"><i class="pi pi-info-circle mr-2"></i>{{ committee.description }}</span>
          </div>
          <!-- Committee Members (readonly, same header style as app-data-table) -->
          <div *ngIf="committee.members?.length" class="border-2 border-gray-200 rounded-lg overflow-hidden mb-4">
            <div
              class="flex flex-wrap items-center justify-between gap-4 px-4 py-2 bg-gray-50/50 border-b border-gray-200">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-md">
                  <i class="text-sm pi pi-database text-blue-600"></i>
                </div>
                <h2 class="text-lg font-bold tracking-tight text-gray-900">Committee Members</h2>
              </div>
            </div>
            <div class="overflow-hidden bg-white">
              <table class="committee-members-readonly-table w-full">
                <thead>
                  <tr>
                    <th>SL NUMBER</th>
                    <th>DESIGNATION</th>
                    <th>ROLE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let member of committee.members">
                    <td>{{ member.slNo }}</td>
                    <td>{{ member.user }}</td>
                    <td>{{ member.role }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div *ngIf="!committee.members?.length" class="flex flex-col items-center justify-center py-8 opacity-70">
            <i class="pi pi-user-minus text-4xl text-slate-300 mb-2"></i>
            <div class="text-base text-slate-500 font-medium">No members found in this committee.</div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="schemeType !='rev'">
      <form [formGroup]="JustificationForm">
        <div class="form-group mb-4 editor-container mt-4" [class.readonly-editor]="isEditorDisabled">
          <label for="pdsTitle"><strong>• Justification</strong></label>
          <!-- <ckeditor [editor]="Editor" [config]="ckEditorConfig" [data]="SOCForm.controls['comment'].value"
                          formControlName="comment" id="pdsTitle">
                      </ckeditor> -->
          <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
        </div>

      </form>
    </ng-container>
  </div>
</div>